<template>
    <Loading :loading="loading" class="device-filter p-2">
        <div class=" d-flex justify-content-end">
            <button
                v-if="showCloseButton"
                class="close-btn pt-1"
                @click="$emit('toggle-filter')"
            >
                <i class="fa fa-times" />
            </button>
        </div>
        <div class="px-3">
            <h3>Price</h3>
        </div>
        <PriceFilter
            :minimumPrice="minimum"
            :maximumPrice="maximum + 1"
            :startSliderValue="selectedMinPrice"
            :endSliderValue="selectedMaxPrice"
            :step="1"
            @price-range-changed="changePrice"
        />

        <div v-if="hasBrands" class="form-group p-3 filter-card">
            <LeftCheckboxFormWithHeading
                heading="Brand"
                :items="allBrands"
                :preselected-items="selectedBrands"
                @selected="handleSelectedBrands"
            ></LeftCheckboxFormWithHeading>
        </div>
        <div v-if="hasCategories" class="form-group p-3 filter-card">
            <LeftCheckboxFormWithHeading
                heading="Category"
                :items="allCategories"
                :preselected-items="selectedCategories"
                @selected="handleSelectedCategories"
            ></LeftCheckboxFormWithHeading>
        </div>
    </Loading>
</template>

<script>
import PriceFilter from "./PriceFilter";
import LeftCheckboxFormWithHeading from "./LeftCheckboxFormWithHeading";
import Loading from "./Loading";
import { getProductPrice } from "../services/ProductPriceCalculator";

export default {
    name: "DeviceFilter",
    components: {
        Loading,
        PriceFilter,
        LeftCheckboxFormWithHeading
    },
    props: {
        minimum: {
            type: Number,
            required: true
        },
        maximum: {
            type: Number,
            required: true
        },
        allProducts: {
            type: Array,
            required: true
        },
        showCloseButton: {
            type: Boolean,
            default: true
        },
        allBrands: {
            type: Array,
            default: () => []
        },
        allCategories: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        filterState: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedMinPrice: 0,
            selectedMaxPrice: this.maximum,
            selectedBrands: [],
            selectedCategories: []
        };
    },
    computed: {
        hasBrands() {
            return this.allBrands && this.allBrands.filter(element => {
                return element !== null && element !== undefined;
            }).length > 0;
        },
        hasCategories() {
            return this.allCategories && this.allCategories.filter(element => {
                return element !== null && element !== undefined;
            }).length > 0;
        }
    },
    watch: {
        filterState: "updateFilterState"
    },
    created() {
        this.updateFilterState();
        this.filter();
    },
    methods: {
        updateFilterState() {
            this.selectedBrands = this.filterState.selectedBrands;
            this.selectedCategories = this.filterState.selectedCategories;
            this.selectedMinPrice = this.filterState.minPrice ?? 0;
            this.selectedMaxPrice = this.filterState.maxPrice ?? this.maximum;
        },
        changePrice($event) {
            this.selectedMinPrice = $event.start;
            this.selectedMaxPrice = $event.end;
            this.filter();
        },
        handleSelectedBrands($event) {
            this.selectedBrands = $event;
            this.filter();
        },
        handleSelectedCategories($event) {
            this.selectedCategories = $event;
            this.filter();
        },
        filter() {
            let filteredProducts = this.allProducts;

            if (this.selectedBrands.length > 0) {
                filteredProducts = filteredProducts.filter(p =>
                    this.selectedBrands.includes(p.Specifications["Brand"])
                );
            }

            if (this.selectedCategories.length > 0) {
                filteredProducts = filteredProducts.filter(p =>
                    this.selectedCategories.includes(p.Specifications["Device"])
                );
            }

            filteredProducts = filteredProducts.filter(p => {
                const pPrice = getProductPrice(p);
                return (
                    pPrice >= this.selectedMinPrice &&
                    pPrice <= this.selectedMaxPrice
                );
            });
            const payload = {
                filteredProducts: filteredProducts,
                filterState: {
                    selectedBrands: this.selectedBrands,
                    selectedCategories: this.selectedCategories,
                    minPrice: this.selectedMinPrice,
                    maxPrice: this.selectedMaxPrice
                }
            };
            this.$emit("products-filtered", payload);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../Presentation/Nop.Web/Themes/MascomTheme/Content/sass/app/variables";

.close-btn {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
    border-radius: 1rem;
    color: $medium-dark-gray;
    background: white;
    border: 2px solid $medium-dark-gray;
}

.device-filter {
    background-color: $light;
    border-top-left-radius: 0;
    border-top-right-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
    border-bottom-left-radius: 0;

    @media (max-width: 575px) {
        position: absolute;
        border-radius: $border-radius;
        border: 2px solid $medium-dark-gray;
    }
}

.filter-card {
    background-color: white;
    border: 4px solid $medium-dark-gray;
    border-radius: $border-radius;
}
</style>
